module.exports = __webpack_public_path__ + "img/flogstad_Sauda_smelteverk1.b8105930.jpg";